var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-5",attrs:{"color":"primary","small":"","outlined":""},on:{"click":_vm.onClick}},[_vm._t("default",[_vm._v("Stop")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }